"use strict";
/* Imports and exports for webpack */

// Expose the component to the global scope
globalThis.UIStats = require("./UIStats.js").default;
